export const DATA_HOOKS = {
  root: 'ai-plan-recommendation-card',
  title: 'ai-recommendation-title',
  body: 'ai-recommendation-body',
  toggle: 'ai-recommendation-toggle',
} as const;
